/**
 * MyWorkspaceEmbedded — May 17, 2026
 *
 * Thin wrapper that mounts <MyWorkspace embedded /> inside AdminLayout's
 * <Outlet />. Resolves the "UI Theme Consistency" ticket: IT and
 * Jurisdiction roles can now open My Workspace from their dark portal
 * (IT Operations Center / Jurisdiction Portal) without being kicked into
 * a separate full-screen Dashboard shell.
 *
 * Renders at `/admin/workspace` — see App.js routing block.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import MyWorkspace from './MyWorkspace';
import { getUserFromToken } from '../../utils/adminApi';

const MyWorkspaceEmbedded = () => {
  const navigate = useNavigate();
  const user = getUserFromToken();
  const role = user?.role;
  // WORKSPACE-SHELL-001 gave IT roles a dark skin; IT-MANAGER-MY-WORKSPACE-UI-001 (Oct 2026)
  // reverts My Workspace to the standard light employee-self-service presentation for every
  // role (the global IT header/sidebar stays dark). `isITRole` now only drives the back target.
  let itContext = false;
  try { itContext = sessionStorage.getItem('titleflow-portal-context') === 'it'; } catch (_) { /* noop */ }
  const isITRole = role === 'it_manager' || role === 'it_support' || (role === 'admin' && itContext);

  // Pick a sensible "back" destination based on the user's portal context.
  const handleBack = () => {
    if (isITRole) {
      navigate('/admin/it-dashboard');
    } else if (role === 'jurisdiction_manager') {
      navigate('/admin/jurisdictions/dashboard');
    } else if (role === 'jurisdiction_requestor') {
      navigate('/admin/my-jurisdiction-dashboard');
    } else {
      navigate('/admin');
    }
  };

  return (
    <MyWorkspace
      currentUser={user}
      onNavigateBack={handleBack}
      embedded
      darkSkin={false}
    />
  );
};

export default MyWorkspaceEmbedded;
